import { schema } from 'normalizr'

const appointmentType = new schema.Entity('appointmentTypes')
const appointmentTypeArray = new schema.Array(appointmentType)
export const appointmentTypeList = { data: appointmentTypeArray }
